import React, { useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  List,
  ListItem,
  Divider,
  Container,
} from '@mui/material';
import api from '../../core/axiosInstance';

const Slip = ({ fileId }) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    setUrl(`${import.meta.env.VITE_API_ENDPOINT}/api/files/upload/${fileId}`);
  }, [fileId]);

  return (
    <Container maxWidth="sm" sx={{ p: { xs: 1, sm: 2 } }}>
      <Paper elevation={3} sx={{ p: { xs: 1, sm: 2 }, mt: 1 }}>
        {/* Header */}
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Box sx={{ width: '100%', maxWidth: '100%' }}>
            <img
              src={url}
              alt="Slip"
              style={{
                maxWidth: '100%',
                height: 'auto',
                display: 'block',
                objectFit: 'contain',
              }}
            />
          </Box>
        </Box>
      </Paper>
    </Container>
  );
};

export default Slip;
